import React, { useRef } from "react";
import "./Hero.scss";
import { NavHashLink as NavLink } from "react-router-hash-link";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomButton from "../../shared/custom-button/custom-button";

const Hero = () => {
  const sliderRef = useRef(null);

  const slides = [
    {
      id: 1,
      title: (
        <>Empowering Growth Through Strategy with Precision & Innovation.</>
      ),
      description:
        "Amicus Growth Advisors helps businesses navigate growth, transformation, and capital strategy with precision.",
      bgImage: "/images/home/hero-1.webp",
      imgMv: "/images/home/hero-mv-1.webp",
      buttonText: "View Our Services",
      buttonLink: "/#key-services",
    },
    {
      id: 2,
      title: <>Empowering Growth Through Governance</>,
      description:
        "Amicus Growth Advisors helps businesses navigate growth, transformation, and capital strategy with precision.",
      bgImage: "/images/home/hero-2.webp",
      imgMv: "/images/home/hero-mv-2.webp",
      buttonText: "View Our Services",
      buttonLink: "/#key-services",
    },
    {
      id: 3,
      title: <>Empowering Growth Through Financial Clarity</>,
      description:
        "Amicus Growth Advisors helps businesses navigate growth, transformation, and capital strategy with precision.",
      bgImage: "/images/home/hero-3.webp",
      imgMv: "/images/home/hero-mv-3.webp",
      buttonText: "View Our Services",
      buttonLink: "/#key-services",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true,
    appendDots: (dots) => (
      <div className="custom-dots">
        <ul> {dots} </ul>
      </div>
    ),
    customPaging: (i) => <div className="dot"></div>,
  };

  const mobileSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true,
    appendDots: (dots) => (
      <div className="custom-dots-mobile">
        <ul> {dots} </ul>
      </div>
    ),
    customPaging: (i) => <div className="dot"></div>,
  };

  return (
    <section className="hero-slider-section">
      {/* Desktop Slider */}
      <div className="desktop-slider-view">
        <Slider ref={sliderRef} {...settings}>
          {slides.map((slide) => (
            <div key={slide.id} className="hero-slide">
              <div
                className="slide-bg"
                style={{
                  backgroundImage: `url(${slide.bgImage})`,
                }}
              >
                <div className="hero-container">
                  <div className="hero-content-wrapper">
                    <div className="hero-left">
                      <h1 className="hero-title">{slide.title}</h1>
                    </div>
                    <div className="hero-right">
                      <p className="hero-description">{slide.description}</p>
                      <div
                        style={{
                          maxWidth: "40%",
                        }}
                      >
                        <CustomButton as={NavLink} to={slide.buttonLink} smooth>
                          {slide.buttonText}
                        </CustomButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Mobile Slider */}
      <div className="mobile-slider-view">
        <Slider {...mobileSettings}>
          {slides.map((slide) => (
            <div key={slide.id} className="mobile-hero-slide">
              <div
                className="mobile-slide-bg"
                style={{
                  backgroundImage: `url(${slide.imgMv})`,
                }}
              >
                <div className="mobile-hero-container">
                  <div className="mobile-hero-content">
                    <h1 className="mobile-hero-title">{slide.title}</h1>
                    <p className="mobile-hero-description">
                      {slide.description}
                    </p>
                    <div className="mobile-hero-button">
                      <CustomButton as={NavLink} to={slide.buttonLink} smooth>
                        {slide.buttonText}
                      </CustomButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Hero;
